module.exports = __webpack_public_path__ + "img/linked-in-bg.9a84bfe4.png";